export type OrderT = "DESC" | "ASC";

export enum ListParamsE {
  page = "page",
  size = "size",
  order = "order",
  search = "search",
  sortBy = "sortBy",
}

export type GetListParamsT<TData extends UnknownRecord = UnknownRecord> = {
  [ListParamsE.page]?: number;
  [ListParamsE.size]?: number;
  [ListParamsE.order]?: OrderT;
  [ListParamsE.search]?: string;
  [ListParamsE.sortBy]?: keyof TData;
};

export type ModelFieldsT = {
  id: UUID;
  createdAt: string;
  updatedAt: string;
};

export type DeletedModelT = {
  isActive: boolean;
  isDeleted: boolean;
};

export type ListResT<Data extends UnknownRecord> = {
  page: number;
  size: number;
  total: number;
  data: Data[];
};

export enum TableNameE {
  BOTS = "bots",
  CHANNELS = "channels",
  LINKS = "links",
  MANAGERS = "managers",
  ACTORS = "actors",
  GROUPS = "groups",
  PROMPTS = "prompts",
  SETTINGS = "settings",
  ACTOR_SETTINGS = "actor_settings",
  SUBSCRIBERS = "subscribers",
  SUBSCRIPTIONS = "subscriptions",
  USERS = "users",
  USER_RESOURCES = "user_resources",
  DIALOG_MESSAGES = "dialog_messages",
  NEWS = "news",
  BLACKLIST = "blacklist",
}

export enum SourceTypeE {
  ACTOR_ENTITY = "ActorEntity",
  BOT_ENTITY = "BotEntity",
  CHANNEL_ENTITY = "ChannelEntity",
  GROUP_ENTITY = "GroupEntity",
  PROMPT_ENTITY = "PromptEntity",
  SETTING_ENTITY = "SettingEntity",
  SUBSCRIBER_ENTITY = "SubscriberEntity",
  SUBSCRIPTION_ENTITY = "SubscriptionEntity",
  USER_ENTITY = "UserEntity",
  USER_RESOURCE_ENTITY = "UserResourceEntity",
  MANAGER_ENTITY = "ManagerEntity",
  SERVICE_ENTITY = "ServiceEntity",
}
